import axios from './axios';
import type { ProjectCategory } from '../types';

export function getCategories(): Promise<ProjectCategory> {
  return axios.get('/categories.json')
    .then(response => response.data);
}

export function createCategory(data: any): ProjectCategory {
  return axios.post('/categories.json', data)
    .then(response => response.data);
}

export function updateCategory(category: ProjectCategory): ProjectCategory {
  return axios.patch(`/categories/${category.id}.json`, category)
    .then(response => response.data);
}

export function deleteCategory(categoryId: number): any {
  return axios.delete(`/categories/${categoryId}.json`)
    .then(() => categoryId);
}
